<template>
  <div class="divide-y divide-slate-200 rounded border">
    <AssignableMaterialResource
      v-for="assignableMaterialResource in assignableMaterialResources"
      :key="assignableMaterialResource.material_resource.id"
      :assignable-material-resource="assignableMaterialResource"
      :with-availability="withAvailability"
      :all-availability-items="allAvailabilityItems"
    />
  </div>
</template>

<script>
import AssignableMaterialResource from '@c/Dashboard/Content/Planning/components/AssignableMaterialResource.vue'

export default {
  name: 'AssignableResourcesList',
  components: { AssignableMaterialResource },
  props: {
    allAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    assignableMaterialResources: {
      type: Array,
      default: () => []
    },
    withAvailability: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
